const ModalStyle = {
  save: {
    textAlign: 'center',
    outline: 'none',
    border: '1px solid #bbbbbb !important',
    borderRadius: '18px !important',
    // backgroundColor: 'var(--purply) !important',
    // color: '#707070 !important',

    padding: '7px 12px 7px 13px !important',
    fontWeight: 'bold !important',
  },
  textField: {
    width: '100% !important',

    // height: '69px !important',
    padding: '0px 5px 5px !important',

    border: '1px solid #d8d8d8 !important',
    borderRadius: '8px',
    margin: '22px',
    '& label.Mui-focused': {
      color: 'white',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'transparent',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'transparent',
      },
      '&:hover fieldset': {
        border: 'transparent',
      },
      '&.Mui-focused fieldset': {
        border: 'transparent',
      },
    },
  },
  High: {
    border: 'solid 2px var(--light-orange)',
  },
  InRange: {
    border: 'solid 2px var(--medium-green)',
  },
  Low: {
    border: 'solid 2px var(--pink)',
  },
  timeIconBlue: {
    color: 'var(--light-blue) !important',
    fontSize: '15px',
  },
  timeIconPurple: {
    color: 'var(--purply) !important',
    fontSize: '15px',
  },
  sugar: {
    margin: 0,

    fontSize: '24px',
    fontWeight: 'bold',
  },
  sugarModal: {
    margin: 0,

    fontWeight: 'bold',
    fontSize: '35px',
  },
  sugarUnit: {
    margin: 0,

    fontSize: '16px',
    fontWeight: 'bold',
  },
  HighColor: {
    color: 'var(--light-orange)',
  },
  InRangeColor: {
    color: 'var(--medium-green)',
  },
  LowColor: {
    color: 'var(--pink)',
  },
  HypoRate: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    fontSize: '16px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'var(--pink)',
  },
  HypoDate: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    fontSize: '16px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: 'var(--purply)',
  },
  Hour: {
    fontSize: '16px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#53585f',
  },
  HypoIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'var(--gray-4)',
    fontSize: '1.3rem',
  },
  sickName: {
    color: 'var(--grey-2)',

    fontSize: '20px',
    fontWeight: 'bold',
    margin: 0,
  },
  expandedSickName: {
    color: 'var(--purply)',

    fontSize: '20px',
    fontWeight: 'bold',
    margin: 0,
  },
  date: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'var(--purply)',

    fontSize: '18px',
    fontWeight: 'bold',
  },
  sickInfo: {
    fontSize: '16px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: 'var(--purply) !important',
    textAlign: 'right',
  },
  sickTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: 'var(--grey-2) !important',
  },
  dateModal: {
    fontSize: '16px',
    textAlign: 'center',
    color: 'var(--purply)',
    fontWeight: 'bold',
  },
  closeBtn: {
    width: '113px !important',
    height: '48px !important',
    borderRadius: '16px !important',
    border: 'solid 1px var(--white) !important',
    backgroundColor: 'var(--white) !important',

    color: '#707070 !important',
    fontSize: '14px !important',
    textAlign: 'center !important',
    fontWeight: '600 !important',
    boxShadow:
      '4px 4px 10px 0 rgba(172, 172, 172, 0.5), -4px -4px 10px 0 var(--white)',
  },
  saveBtn: {
    // border:'1px solid #ffffff !important',
    width: '175px !important',
    height: '48px !important',
    textAlign: 'center !important',
    borderRadius: '16px !important',

    fontSize: '14px !important',
    fontWeight: '600 !important',
    cursor: 'pointer !important',
    boxShadow:
      '4px 4px 10px 0 rgba(172, 172, 172, 0.5), -4px -4px 10px 0 var(--white)',
  },
  customTextField: {
    '& .MuiInputBase-input-MuiOutlinedInput-input ': {
      '. &::placeholder': {
        // textOverflow: 'ellipsis !important',
        color: 'blue',
      },
    },
  },
  estimateAlert: {
    // margin: ' 0 0 0 5px',

    fontSize: '12px',
    color: 'var(--purply)',
    textAlign: 'left',
  },
  estimateAlert2: {
    marginTop: '2px',

    fontSize: '12px',
    color: '#222222',
    textAlign: 'left',
  },
  editEstimateBtn: {
    width: '92px !important',
    height: '29px !important',
    display: 'flex !important',
    justifyContent: 'center!important',
    paddingBottom: '8px !important',
    borderRadius: '16px !important',
    border: 'solid 1px #d8d8d8 !important',

    backgroundColor: '#FFFFFF !important',
  },
  header: {
    height: '106px',
    backgroundColor: '#FFFFFF',
    padding: '24px 13px 12px',
    borderRadius: '16px 16px 0 0',
  },
  editIcon: {
    padding: '0 5px',
  },
  Line: {
    width: '90%',
    border: 'solid 1px var(--white)',
    backgroundColor: 'var(--white)',
  },
};

export default ModalStyle;
